import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {Session} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/session.types';
import {WishlistPageService_GetTreeNavigationLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/wishlist/v1/page/service.grpc.lazy';
import {useFullSession} from '@aboutyou/user';
import {useReductionsStateRequestParameter} from '../../../features/ReductionsState/useReductionsStateRequestParameter';
import {useTargetGroupIdentifier} from '../../../shared-deprecated/useTargetGroupIdentifier';

export const useWishlistTree = () => {
  const targetGroup = useTargetGroupIdentifier();
  const session = useFullSession();

  return useGrpcRequest(
    WishlistPageService_GetTreeNavigationLazy,
    {
      session: session as Session,
      targetGroup,
      reductionsState: useReductionsStateRequestParameter(),
    },
    {
      disabled: !session,
    },
  );
};
